import React, {Component} from 'react';
import {Link} from 'react-router-dom';

import {Grid} from 'react-bootstrap';
import Breadcrumbs from 'system/breadcrumbs';
import {Wrapper} from 'system/wrapper';
import DetailList from 'system/list/detail';

class UnitDetail extends Component {
  render() {
    return(
      <div>
        <Breadcrumbs>
          <li><Link to="/">Головна</Link></li>
          <li><Link to="/infocenter">Департамент охорони здоров’я</Link></li>
          <li><Link to="/infocenter/projects">Підрозділи</Link></li>
          <li><Link to="/infocenter/projects/detail">Підрозділи #1</Link></li>
        </Breadcrumbs>
        <Wrapper>
          <Grid>
            <h2>Проект #1</h2>
            <DetailList>
              <li><span>Коротка назва: </span>Example</li>
              <li><span>Повна назва: </span>Example</li>
              <li><span>Адреса: </span>Example</li>
              <li><span>ID: </span>Example</li>
              <li><span>Основний вид діяльності: </span>Example</li>
            </DetailList>
          </Grid>
        </Wrapper>
      </div>
    )
  }
}

export default UnitDetail;



// WEBPACK FOOTER //
// ./src/system/management/units/detail.js